import React, { Component } from 'react';
import MathJax from '../component/react-mathjax-preview';
import { Cell, Grid } from 'react-md';
import { NotificationManager } from 'react-notifications';
import ApiRequestService from '../component/ApiRequestService';
import LoadingSpinner from '../component/LoadingSpinner';
import TextEditor from '../component/TextEditor';


export default class AboutPage extends Component {

    constructor(props){
        super(props);
        this.state = {
          pageLoading: false,
          tempUserId: ''    ,    
          DynamicText:"",
          loadingTechTrouble: false,            
          DynamicTextEditorObj: TextEditor.createEmptyValue(),  
        };
       this.getDynamicData = this.getDynamicData.bind(this);
    }
    
    componentDidMount(){
        this.getDynamicData();
    }
    getDynamicData = async() =>{
        this.setState({loadingTechTrouble:true});
        
        try{
            const payload = {        
                type: 4
            };
            
            let activityResp = await ApiRequestService({
            method: 'post',
            url: "/getDynamicData",
            data: payload
            })
            if(activityResp.data !== undefined && activityResp.data !== null){
                if(activityResp.data.status === 0 &&  activityResp.data.data){
                    var tempDynamicText = activityResp.data.data.text;     
                    
                    this.setState({
                        DynamicTextEditorObj: tempDynamicText
                    });
                                  
                    
                }else if (activityResp.data.message !== undefined &&  activityResp.data.message !== null ) {
                    NotificationManager.error(activityResp.data.message,"Error",5000);
                }else{
                    NotificationManager.error("Getting  data failed with Unknown Error","Error",5000);
                }
            }else{
                NotificationManager.error("Getting  data failed with Unknown Error","Error",5000);
            }
            
        }catch(err){
            NotificationManager.error(err,"Error",5000);
        }finally{
            this.setState({loadingTechTrouble:false});
         }
    }

  
    render() {
        if (this.state.pageLoading) {
            return <LoadingSpinner />;
          }
        
        return (
            <Grid style = {{marginTop: '-65px'}}>
                <Cell size={8}>
                    <h1>About </h1>
                </Cell>
                <Cell style={{color: '#576271', marginLeft:"30px"}}><br/><br/>
                    <MathJax  className="trouble-shooting-style" math={this.state.DynamicTextEditorObj.toString('html',null)} />
                </Cell>
            </Grid>
        );
     }
}
